const AVAILABILITY = {
	NONE: "none",
	LIMITED: "limited",
	AVAILABLE: "available",
};

export default AVAILABILITY;
